<template>
  <div id="checklistTwo"></div>
</template>

<script>
export default {
  name: "ChecklistTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        title: "Content Launch Checklist",
        items: [
          { text: "Write compelling headline", checked: true },
          { text: "Add visuals and graphics", checked: true },
          { text: "Proofread for errors", checked: false },
          { text: "Schedule for optimal time", checked: false },
        ],
        chip: "Checklist",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("checklistTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const titleSize = exporting ? 48 : 48 * this.scale;
      const itemSize = exporting ? 28 : 28 * this.scale;
      const checkSize = exporting ? 28 : 28 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      const items = this.data.items || [];
      const itemsHtml = items
        .map(
          (item) => `
        <div style="display: flex; align-items: center; margin-bottom: 24px;">
          <div style="
            min-width: ${checkSize}px;
            height: ${checkSize}px;
            border: 2px solid ${item.checked ? primaryColor : "rgba(255,255,255,0.3)"};
            background: ${item.checked ? primaryColor : "transparent"};
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            flex-shrink: 0;
          ">
            ${item.checked ? `<span style="color: white; font-size: ${checkSize * 0.5}px; font-weight: bold;">✓</span>` : ""}
          </div>
          <div style="
            font-size: ${itemSize}px;
            font-weight: 400;
            color: ${item.checked ? "#ffffff" : "rgba(255,255,255,0.5)"};
            line-height: 1.3;
            ${item.checked ? "" : "text-decoration: none;"}
          ">${item.text}</div>
        </div>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effect -->
          <div style="
            position: absolute;
            top: -20%;
            right: -20%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, ${primaryColor}25 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, #6366f130 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Checklist content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1;">
            <div style="
              font-size: ${titleSize}px;
              font-weight: 600;
              color: #ffffff;
              line-height: 1.2;
              margin-bottom: 40px;
              display: flex;
              align-items: center;
              gap: 16px;
            ">
              <div style="
                width: 4px;
                height: 48px;
                background: linear-gradient(180deg, ${primaryColor} 0%, #6366f1 100%);
                border-radius: 2px;
              "></div>
              ${this.data.title}
            </div>

            <div style="padding-left: 20px;">
              ${itemsHtml}
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
